import React from 'react';
import Dialog from '../../dialog';
import Box from '../../layout/box';
import { callWith } from '../../../../util';

function BaseDialog({children, onClose, confirmBtnTxt = "OK", cancelBtnTxt = "Cancel", fieldActionRequest, validateFieldPath, findDataForPath, disableConfirm, ...props}) {
	const body = (
		<Box type="column">
			{children}
		</Box>
	);
	return (
		<Dialog 
			{...props} 
			confirmBtnTxt={confirmBtnTxt} 
			cancelBtnTxt = {cancelBtnTxt}
			onConfirm={callWith(onClose, true)}
			onCancel={callWith(onClose, false)}
			body={body}
			disableConfirm={disableConfirm}
			/>
	);
}

export default BaseDialog;